var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"overflow":"visible !important"},attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":"50%","stroke-width":"0.5","stroke":_vm.highlighted(),"fill":_vm.background}}),_c('text',{attrs:{"x":"33","y":"53","fill":"#e2e2e2","font-size":"0.6rem","font-weight":"normal"}},[_vm._v(" Badge ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }